function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], [tabindex]:not([tabindex^='-']), button:enabled, [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}


// ~~~ DEAL WITH <SUMMARY> ACCESSIBILITY ATTRS ~~~ 
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {

	summary.setAttribute('role', 'button');
	summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id);
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
	});

	if (summary.closest('header-drawer, menu-drawer')) return;
	summary.parentElement.addEventListener('keyup', onKeyUpEscape);

});


// ~~~ TRAP FOCUS AND CYCLE THROUGH ~~~ 
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {

	//console.log(container, elementToFocus)
	var elements = getFocusableElements(container);
	//console.log(elements)
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;
		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus.focus();

	if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
		// The setSelectionRange method is used to set the selection range within a text input or textarea element. 
		// It takes two parameters:
		//   1) The index of the first character in the selected text.
		//   2) The index of the character following the last character in the selected text.
		elementToFocus.setSelectionRange(0, elementToFocus.value.length);
	}

}


// ~~~ FOCUS VISIBLE TESTER AND POLYFILL FALLBACK ~~~
try { document.querySelector(':focus-visible') } catch (e) { focusVisiblePolyfill() }
function focusVisiblePolyfill() {

	const navKeys = [
		'ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT',
		'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END',
		'PAGEUP', 'PAGEDOWN',
	];

	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) { mouseClick = false }
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = true;
	});

	window.addEventListener('focus', () => {
		if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
		if (mouseClick) return;
		currentFocusedElement = document.activeElement;
		currentFocusedElement.classList.add('focused');
	}, true);

}


// ~~~ REMOVE TRAP FOCUS ~~~ 
function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);
	if (elementToFocus) elementToFocus.focus();
}


// ~~~ ON ESC KEY PRESS, CLOSE CLOSEST DETAILS ELEMENT ~~~
function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;
	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;
	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
}


// ~~~ QTY INPUTS ~~~
class QuantityInput extends HTMLElement {


	constructor() {

		super();
		this.input = this.querySelector('input');

		// Creates a custom 'change' event called changeEvent. 
		// The { bubbles: true } option means that this event can bubble up through the DOM, 
		// allowing it to be caught by event listeners on ancestor elements.
		this.changeEvent = new Event('change', { bubbles: true });

		this.input.addEventListener('change', this.onInputChange.bind(this));

		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this))
		);

	}
	quantityUpdateUnsubscriber = undefined;


	connectedCallback() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
	}


	disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}


	onInputChange(event) {
		this.validateQtyRules();
	}


	onButtonClick(event) {

		event.preventDefault();
		const previousValue = this.input.value;
		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

	}


	validateQtyRules() {

		const value = parseInt(this.input.value);

		if (this.input.min) {
			const min = parseInt(this.input.min);
			const buttonMinus = this.querySelector(".quantity-button[name='minus']");
			buttonMinus.classList.toggle('disabled', value <= min);
		}

		if (this.input.max) {
			const max = parseInt(this.input.max);
			const buttonPlus = this.querySelector(".quantity-button[name='plus']");
			buttonPlus.classList.toggle('disabled', value >= max);
		}

	}


}
customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}


function throttle(fn, delay) {
	let lastCall = 0;
	return function (...args) {
		const now = new Date().getTime();
		if (now - lastCall < delay) {
			return;
		}
		lastCall = now;
		return fn(...args);
	};
}


// ~~~ HELPER FUNCTION FOR AJAX CALLS ~~~
function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	};
}


// ~~~ SHOPIFY COMMON JS ~~~
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}


Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};


Shopify.setSelectorByValue = function (selector, value) {

	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}

};


Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};


Shopify.postLink = function (path, options) {

	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}

	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);

};


Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {

	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();

};


Shopify.CountryProvinceSelector.prototype = {

	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = '';
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},

};


class VariantSelects extends HTMLElement {


	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}


	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '', false);
		this.removeErrorMessage();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}


	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
	}


	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			// wot?
			return !variant.options
				.map((option, index) => { return this.options[index] === option }).includes(false);
		});
	}


	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}


	updateVariantInput() {
		const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}


	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked').value === variant.option1);
		const inputWrappers = [...this.querySelectorAll('.product-form-input')];

		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}


	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.innerText = input.getAttribute('value');
			} else {
				input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
			}
		});
	}


	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}


	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

		fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const destination = document.getElementById(`price-${this.dataset.section}`);
				const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
				const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
				const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
				const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
				const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
				const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

				if (qtyRules) qtyRules.classList.remove('hidden');

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
				}

				// if (volumePricingSource && volumePricingDestination) {
				// 	volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
				// }

				// if (pricePerItemSource && pricePerItemDestination) {
				// 	pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
				// 	pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
				// }

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('hidden');

				if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

				const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
					window.variantStrings.soldOut
				);

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant,
					},
				});
			});
	}


	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}


	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);

		const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('hidden');
		if (inventory) inventory.classList.add('hidden');
		if (sku) sku.classList.add('hidden');
		if (pricePerItem) pricePerItem.classList.add('hidden');
		if (volumeNote) volumeNote.classList.add('hidden');
		if (volumeTable) volumeTable.classList.add('hidden');
		if (qtyRules) qtyRules.classList.add('hidden');
	}


	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}


}
customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {


	constructor() {
		super();
	}


	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled');
			} else {
				input.classList.add('disabled');
			}
		});
	}


	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
		});
	}

}
customElements.define('variant-radios', VariantRadios);


class ProductRecommendations extends HTMLElement {


	constructor() {
		super();
	}


	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (html.querySelector('.grid-item')) {
						this.classList.add('product-recommendations--loaded');
					}

					new ScrollAnimations();


				})
				.catch((e) => {
					console.error(e);
				});
		};
		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
	}


}
customElements.define('product-recommendations', ProductRecommendations);


class CartProductRecommendations extends HTMLElement {


	constructor() {
		super();
	}


	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (html.querySelector('.grid-item')) {
						this.classList.add('product-recommendations--loaded');
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};
		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
	}


}
customElements.define('cart-product-recommendations', CartProductRecommendations);


class ScrollContainer extends HTMLElement {


	constructor() {
		super();

		this.scrollContainer = this.querySelector('[data-scrollercontainer]');
		this.containerWidth = this.scrollContainer.offsetWidth;
		this.itemWidth = this.scrollContainer.querySelector('li').offsetWidth;

		this.cartRecommendations = this.closest('.cart-recommended-products');

		const computedStyle = getComputedStyle(this.scrollContainer);
		this.computedGapValue = computedStyle.getPropertyValue('gap');
		this.gapValue = parseFloat(this.computedGapValue);
		//console.log(this.gapValue)

		this.scrollAmount = this.itemWidth + (this.gapValue * 3);

		// Find the badges carousel if it exists
		this.badgesCarousel = this.closest('.gtn-badges-wrapper') ? this.closest('.gtn-badges-wrapper').querySelector('.badges-carousel') : null;

		this.checkOverflow()
		window.addEventListener('resize', () => this.checkOverflow());

		this.buttonsCreated = false;
		this.dummyItemCreated = false;

		if (this.cartRecommendations) {
			this.setupCartPagination();
		}

		// Add debounced scroll handler for badges carousel
		if (this.badgesCarousel) {
			this.checkScrollPosition();
			let scrollTimeout;
			this.scrollContainer.addEventListener('scroll', () => {
				if (scrollTimeout) {
					window.cancelAnimationFrame(scrollTimeout);
				}
				scrollTimeout = window.requestAnimationFrame(() => {
					this.checkScrollPosition();
				});
			});

			const resizeObserver = new ResizeObserver(() => this.checkScrollPosition());
			resizeObserver.observe(this.scrollContainer);
		}
	}

	setupCartPagination() {
		// Get pagination elements
		this.leftBtn = this.querySelector('.scroll-left-button');
		this.rightBtn = this.querySelector('.scroll-right-button');
		this.currentPageEl = this.querySelector('.current-page');

		// Calculate pages
		this.itemsPerPage = 3;
		this.totalItems = this.scrollContainer.querySelectorAll('li').length;
		this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
		this.currentPage = 1;

		// Add event listeners
		if (this.leftBtn && this.rightBtn) {
			this.leftBtn.addEventListener('click', () => this.scroll('left'));
			this.rightBtn.addEventListener('click', () => this.scroll('right'));
		}

		// Add scroll event listener
		this.scrollContainer.addEventListener('scroll', () => {
			requestAnimationFrame(() => {
				this.updateCartPagination();
			});
		});

		// Initial update
		this.updateCartPagination();
	}

	updateCartPagination() {
		if (!this.cartRecommendations) return;

		const scrollPosition = this.scrollContainer.scrollLeft;
		const viewportWidth = this.scrollContainer.offsetWidth;

		// Calculate current page
		this.currentPage = Math.floor(scrollPosition / viewportWidth) + 1;

		// Update page number
		if (this.currentPageEl) {
			this.currentPageEl.textContent = this.currentPage;
		}

		// Update button states
		if (this.leftBtn && this.rightBtn) {
			this.leftBtn.disabled = this.currentPage === 1;
			this.rightBtn.disabled = this.currentPage >= this.totalPages;
		}
	}

	scroll(direction) {
		if (this.cartRecommendations) {
			const viewportWidth = this.scrollContainer.offsetWidth;
			const scrollAmount = direction === 'left' ? -viewportWidth : viewportWidth;

			this.scrollContainer.scrollBy({
				left: scrollAmount,
				behavior: 'smooth'
			});

			// Update current page
			this.currentPage = direction === 'left' ?
				Math.max(1, this.currentPage - 1) :
				Math.min(this.totalPages, this.currentPage + 1);
		} else {
			direction === 'left' ?
				this.scrollContainer.scrollLeft -= this.scrollAmount :
				this.scrollContainer.scrollLeft += this.scrollAmount;
		}
	}

	createButtons() {


		if (this.badgesCarousel && this.badgesCarousel.querySelectorAll('li').length < 3) return;
		const leftButton = document.createElement('button');
		leftButton.setAttribute('aria-label', 'Scroll left');
		leftButton.setAttribute('type', 'button');
		leftButton.classList.add('scroll-button', 'scroll-left-button');
		leftButton.innerHTML = `<svg class="[ icon icon-caret-left ]" style="width: 2rem; height: 2rem;" aria-hidden="true" focusable="false"><use href="#icon-caret-left"></svg>`;
		leftButton.addEventListener('click', () => this.scroll('left'));
		this.appendChild(leftButton);
		this.leftBtn = this.querySelector('.scroll-left-button');

		const rightButton = document.createElement('button');
		rightButton.setAttribute('aria-label', 'Scroll right');
		rightButton.setAttribute('type', 'button');
		rightButton.classList.add('scroll-button', 'scroll-right-button');
		rightButton.innerHTML = `<svg class="[ icon icon-caret-right ]" style="width: 2rem; height: 2rem;" aria-hidden="true" focusable="false"><use href="#icon-caret-right"></svg>`
		rightButton.addEventListener('click', () => this.scroll('right'));
		this.appendChild(rightButton);
		this.rightBtn = this.querySelector('.scroll-right-button');

		this.buttonsCreated = true;

	}

	createDummyItem() {
		const dummyItem = document.createElement('li');
		dummyItem.classList.add('dummy-item', 'pdg-r-3vw');
		dummyItem.setAttribute('aria-hidden', 'true');
		this.scrollContainer.appendChild(dummyItem);

		this.dummyItemCreated = true;
	}


	handleScroll() {

		const isAtStart = this.scrollContainer.scrollLeft === 0;
		const isAtEnd = this.scrollContainer.scrollLeft >= this.scrollContainer.scrollWidth - this.scrollContainer.offsetWidth;

		if (isAtStart) {
			this.leftBtn.disabled = true;
			this.rightBtn.disabled = false;
		} else if (isAtEnd) {
			this.leftBtn.disabled = false;
			this.rightBtn.disabled = true;
		} else {
			this.leftBtn.disabled = false;
			this.rightBtn.disabled = false;
		}

		// Update fade effect if badges carousel exists
		if (this.badgesCarousel) {
			this.checkScrollPosition();
		}
	}

	// New method for fade effect
	checkScrollPosition() {
		if (!this.badgesCarousel) return;

		const scrollLeft = this.scrollContainer.scrollLeft;
		const maxScroll = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
		const listItems = this.badgesCarousel.querySelectorAll('li').length
		// Remove all classes first
		this.badgesCarousel.classList.remove('badges-carousel-left', 'badges-carousel-right');

		// If at the end, show left fade, otherwise show right fade

		if (Math.abs(scrollLeft - maxScroll) < 1 && listItems > 3) {
			this.badgesCarousel.classList.add('badges-carousel-left');
		} else {
			this.badgesCarousel.classList.add('badges-carousel-right');
		}
	}


	checkOverflow() {

		if (!this.buttonsCreated && !this.dummyItemCreated && this.scrollContainer.scrollWidth > this.scrollContainer.offsetWidth) {
			// Create buttons only if they haven't been created before

			this.createButtons();
			this.createDummyItem();
			this.handleScroll();

			// Remove existing scroll event listener before adding a new one
			this.scrollContainer.removeEventListener('scroll', () => this.handleScroll());
			this.scrollContainer.addEventListener('scroll', () => this.handleScroll());
			// Only apply padding-right if NOT in partners section
			if (!this.closest('.partners-carousel')) {
				this.scrollContainer.style.paddingRight = '0';
			}
		} else {
			// Create buttons if in Product Good To Know section
			if (this.closest('.gtn-badges-wrapper')) {
				this.createButtons();
			}
			// Only apply padding-right if NOT in partners section

			if (!this.closest('.partners-carousel')) {
				this.scrollContainer.style.paddingRight = 'calc(3vw - 0.5rem)';
			}
		}
	}


}
customElements.define('scroller-container', ScrollContainer);


class BoxesWithModal extends HTMLElement {

	constructor() {
		super();
		this.modal_elements = this.querySelectorAll('.featured-box-modal-wrapper');
		this.modal_elements.length > 0 ? (
			this.addListeners(),
			this.modal_elements.length > 1 ? this.createModalControls() : null
		) : null;
	}


	addListeners() {
		this.modal_elements.forEach(el => {

			//let modal_id = el.getAttribute('data-id');
			let openBtn = el.querySelector('.modal-opener');
			let closeBtn = el.querySelector('.modal-closer');
			let modal_main = el.querySelector('.featured-box-modal');
			let modal_content = el.querySelector('.featured-box-modal-content');

			openBtn.addEventListener('click', () => { this.modalOpen(modal_main, modal_content, el) });
			closeBtn.addEventListener('click', () => { this.modalClose(modal_main, modal_content, el) });
			modal_main.addEventListener('click', () => { this.handleInnerClick(modal_main, modal_content) });
			modal_content.addEventListener('keydown', () => { this.handleKeyboard(modal_main, modal_content) });

		})

	}


	modalOpen(modal_main, modal_content) {
		document.documentElement.style.overflow = 'hidden';
		modal_main.classList.add('on');
		modal_content.focus();
		setTimeout(() => { modal_content.classList.add('on') });
	}


	modalClose(modal_main, modal_content) {
		document.documentElement.style.overflow = 'unset';
		modal_content.classList.remove('on');
		setTimeout(() => { modal_main.classList.remove('on') }, 300);
	}


	handleKeyboard(modal_main, modal_content) {

		// Trap focus and cycle through focusable elements within the modal
		if (event.key === 'Tab') {
			const focusableElements = Array.from(modal_content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
			const firstElement = focusableElements[0];
			const lastElement = focusableElements[focusableElements.length - 1];

			if (!event.shiftKey && document.activeElement === lastElement) {
				event.preventDefault();
				firstElement.focus();
			} else if (event.shiftKey && document.activeElement === firstElement) {
				event.preventDefault();
				lastElement.focus();
			}
		}

		// Close the damn thing
		if (event.key === 'Escape') {
			this.modalClose(modal_main, modal_content);
		}


	}


	handleInnerClick(modal_main, modal_content) {
		if (event.target === modal_main) {
			this.modalClose(modal_main, modal_content);
		}
	}


	createModalControls() {

		const numElements = this.modal_elements.length;

		this.modal_elements.forEach((el, index) => {

			const prevIndex = (index - 1 + numElements) % numElements;
			const nextIndex = (index + 1) % numElements;

			// prev
			let modal_control_prev = document.createElement('button');
			modal_control_prev.setAttribute('type', 'button');
			modal_control_prev.textContent = 'PREV';
			modal_control_prev.classList.add('modal-control', 'prev');
			modal_control_prev.setAttribute('data-id', this.modal_elements[prevIndex].getAttribute('data-id'));
			el.querySelector('.modal-controls').appendChild(modal_control_prev);

			// next
			let modal_control_next = document.createElement('button');
			modal_control_next.setAttribute('type', 'button');
			modal_control_next.textContent = 'NEXT';
			modal_control_next.classList.add('modal-control', 'next');
			modal_control_next.setAttribute('data-id', this.modal_elements[nextIndex].getAttribute('data-id'));
			el.querySelector('.modal-controls').appendChild(modal_control_next);

			// add listeners
			modal_control_prev.addEventListener('click', () => { this.toggleModal() });
			modal_control_next.addEventListener('click', () => { this.toggleModal() });

		})
	}


	toggleModal() {
		const modal_id = event.target.dataset.id;
		const modal_to_close = this.querySelector('.featured-box-modal.on');
		const modal_content_to_close = modal_to_close.querySelector('.featured-box-modal-content.on');
		this.modalClose(modal_to_close, modal_content_to_close)

		const target = this.querySelector(`.featured-box-modal-wrapper[data-id="${modal_id}"`);
		const modal_to_open = target.querySelector('.featured-box-modal');
		const modal_content_to_open = modal_to_open.querySelector('.featured-box-modal-content');
		this.modalOpen(modal_to_open, modal_content_to_open)
	}



}
customElements.define("boxes-with-modal", BoxesWithModal);


class ScrollerCtaLink extends HTMLElement {


	constructor() {
		super();
		this.anchor = this.querySelector('a');
	}


	connectedCallback() {
		this.getNextSection();
		this.addEventListener('click', this.handleClick);
	}


	getNextSection() {
		let currentSection = this.closest('.shopify-section');
		this.nextSection = currentSection.nextElementSibling;
		if (this.nextSection !== null && this.nextSection.classList.contains('shopify-section')) {
			this.anchor.href = `#${this.nextSection.id}`;
		}
	}


	handleClick(event) {
		event.preventDefault();
		this.nextSection.scrollIntoView({ behavior: 'smooth' });
	}


}
customElements.define('scroller-cta-link', ScrollerCtaLink);


class ContentCarousel extends HTMLElement {


	constructor() {
		super();
		this.currentSlideIndex = 0;
		this.slides = [];
		this.buttons = [];
	}


	connectedCallback() {
		this.slides = Array.from(this.querySelectorAll('.item'));
		this.prepareSlides();
		this.showSlide(this.currentSlideIndex);
		if (this.slides.length > 1) {
			this.renderButtons();
		}
	}


	renderButtons() {

		const buttonsContainer = document.createElement('div');
		buttonsContainer.setAttribute('role', 'group');
		buttonsContainer.setAttribute('aria-label', 'Carousel Controls');
		buttonsContainer.classList.add('controls');

		for (let i = 0; i < this.slides.length; i++) {
			const button = document.createElement('button');
			button.setAttribute('aria-label', `Go to Slide ${i + 1}`);
			button.textContent = i + 1;
			button.setAttribute('aria-current', i === this.currentSlideIndex ? 'true' : 'false');
			button.addEventListener('click', () => this.goToSlide(i));
			buttonsContainer.appendChild(button);
			this.buttons.push(button);
		}

		this.appendChild(buttonsContainer);
		this.setActiveButton(this.currentSlideIndex);
	}


	setActiveButton(index) {
		this.buttons.forEach((button, i) => {
			i === index ? button.classList.add('active') : button.classList.remove('active');
			button.setAttribute('aria-current', i === index ? 'true' : 'false');
		});
	}


	prepareSlides() {
		this.slides.forEach((slide, i) => {
			slide.setAttribute('role', 'group');
			slide.setAttribute('aria-roledescription', 'Slide');
			slide.setAttribute('tabindex', '-1');

			const heading = slide.querySelector('h3');
			if (heading) {
				heading.id = `${this.dataset.id}-slide-heading-${i}`;
				slide.setAttribute('aria-labelledby', heading.id);
			}
		});
	}


	showSlide(index) {

		this.slides.forEach(slide => {
			slide.style.display = 'none';
			slide.classList.remove('on');
		});

		this.slides[index].style.display = 'grid';
		setTimeout(() => this.slides[index].classList.add('on'), 10);
		this.slides[index].focus();
		this.setActiveButton(index);
	}


	goToSlide(index) {
		this.currentSlideIndex = index;
		this.showSlide(this.currentSlideIndex);
	}


}
customElements.define('content-carousel', ContentCarousel);

/*
class DetailsDrawer extends HTMLElement {


	constructor() {
		super();
		this.details = this.querySelector('details');
		this.summary = this.details.querySelector('summary');
		this.content = this.summary.nextElementSibling;
		this.closeBtn = this.content.querySelector('.drawer-close');	
		
		if (!this.details.hasAttribute('id')) {
			this.details.setAttribute('id', 'drawer_' + Math.random().toString(36));
			this.content.setAttribute('id', 'drawer_content_' + Math.random().toString(36));
		}

		this.summary.setAttribute('role', 'button');
		this.summary.setAttribute('aria-controls', this.content.getAttribute('id'));
		this.summary.setAttribute('aria-expanded', this.details.hasAttribute('open'));

	}


	connectedCallback() {
		if (this.summary) {
			this.summary.addEventListener('click', this.toggleDrawer.bind(this));
			this.summary.addEventListener('keydown', this.handleKeyboard.bind(this));	
		}

		if (this.closeBtn) {
			this.closeBtn.addEventListener('click', this.closeDrawer.bind(this));
		}

		this.addEventListener('click', this.clickOutsideDrawer.bind(this));
		document.addEventListener('keydown', this.handleKeyboard.bind(this));
	}


	disconnectedCallback() {
		if (this.summary) {
			this.summary.removeEventListener('click', this.toggleDrawer.bind(this));
			this.summary.removeEventListener('keydown', this.handleKeyboard.bind(this));
		}

		if (this.closeBtn) {
				this.closeBtn.removeEventListener('click', this.closeDrawer.bind(this));
		}

		this.removeEventListener('click', this.clickOutsideDrawer.bind(this));
		document.removeEventListener('keydown', this.handleKeyboard.bind(this));
	}


	closeOtherDrawers(event) {
		const allDrawers = document.querySelectorAll('details-drawer');
		allDrawers.forEach(drawer => {
			if (drawer !== this && drawer.details.hasAttribute('open')) {
				drawer.closeDrawer(event);
			}
		});
	}


	closeDrawer(event) {
		event.preventDefault();
		if (this.details.hasAttribute('open')) {
			this.classList.remove('animate')
			setTimeout(()=> { this.classList.remove('on') },250)
			this.summary.setAttribute('aria-expanded', 'false');
			setTimeout(()=> { 
				this.details.removeAttribute('open'); 
				this.dealWithPageScroll();
			}, 260)
		}
	}


	toggleDrawer(event) {
		event.preventDefault();
		this.closeOtherDrawers(event);	
		if (this.details.hasAttribute('open')) {
			this.classList.remove('animate')
			setTimeout(()=> { this.classList.remove('on') },250)
			this.summary.setAttribute('aria-expanded', 'false');
			setTimeout(()=> { 
				this.details.removeAttribute('open'); 
				this.dealWithPageScroll();
			}, 260)
		} else {
			this.details.setAttribute('open', '');
			this.summary.setAttribute('aria-expanded', 'true');
			this.dealWithPageScroll();
			setTimeout(()=> { 
				this.classList.add('on');
				setTimeout(()=> { this.classList.add('animate') },10)
				this.dealWithFocus();
			})
		}
		
	}
	

	dealWithPageScroll() {
		this.details.hasAttribute('open') ? document.documentElement.classList.add('overflow-hidden') : document.documentElement.classList.remove('overflow-hidden');	
	}


	dealWithFocus() {
		trapFocus(this.content);
		const focusableElements = getFocusableElements(this.content);
		if (focusableElements.length > 0) {
			focusableElements[0].focus();
		}
	}


	clickOutsideDrawer(event) {
		if (event.target.tagName.toLowerCase() === 'details-drawer' && !event.target.closest('.drawer-content'))  {
			this.closeDrawer(event)
		}
	}


	handleKeyboard(event) {
		if (event.key === 'Escape') {		
			this.closeDrawer(event);
		}
	}


}*/

class DetailsDrawer extends HTMLElement {
	constructor() {
		super();
		this.details = this.querySelector('details');
		this.summary = this.details.querySelector('summary');
		this.content = this.summary.nextElementSibling;
		this.closeBtn = this.content.querySelector('.drawer-close');

		if (!this.details.hasAttribute('id')) {
			this.details.setAttribute('id', 'drawer_' + Math.random().toString(36));
			this.content.setAttribute('id', 'drawer_content_' + Math.random().toString(36));
		}

		this.summary.setAttribute('role', 'button');
		this.summary.setAttribute('aria-controls', this.content.getAttribute('id'));
		this.summary.setAttribute('aria-expanded', this.details.hasAttribute('open'));

		// Check if this is a menu drawer and we're on desktop
		this.isMenuDrawer = this.closest('.menu-drawer') !== null;
		this.mediaQuery = window.matchMedia('(max-width: 80em)');

		// Hover timer to prevent immediate closing
		this.hoverTimer = null;
		this.isHovering = false;
	}

	connectedCallback() {
		// Always add click handlers for mobile and accessibility
		if (this.summary) {
			this.summary.addEventListener('click', this.toggleDrawer.bind(this));
			this.summary.addEventListener('keydown', this.handleKeyboard.bind(this));
		}

		if (this.closeBtn) {
			this.closeBtn.addEventListener('click', this.closeDrawer.bind(this));
		}

		this.addEventListener('click', this.clickOutsideDrawer.bind(this));
		document.addEventListener('keydown', this.handleKeyboard.bind(this));

		// Add hover functionality for desktop menu drawers
		if (this.isMenuDrawer) {
			this.updateHoverListeners();
			// Re-evaluate when media query changes
			this.mediaQuery.addEventListener('change', this.updateHoverListeners.bind(this));
		}
	}

	updateHoverListeners() {
		// Only add hover for desktop (when media query doesn't match)
		if (this.isMenuDrawer && !this.mediaQuery.matches) {
			// Use mouseenter/mouseleave for the entire drawer
			this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
			this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
			this.addEventListener('mousemove', this.handleMouseMove.bind(this));
		} else {
			// Remove hover events for mobile
			this.removeEventListener('mouseenter', this.handleMouseEnter.bind(this));
			this.removeEventListener('mouseleave', this.handleMouseLeave.bind(this));
		}
	}

	handleMouseEnter() {
		// Clear any pending close timer
		if (this.hoverTimer) {
			clearTimeout(this.hoverTimer);
			this.hoverTimer = null;
		}

		this.isHovering = true;

		// Only open if not already open
		if (!this.details.hasAttribute('open')) {
			this.details.setAttribute('open', '');
			this.summary.setAttribute('aria-expanded', 'true');

			setTimeout(() => {
				this.classList.add('on');
				setTimeout(() => { this.classList.add('animate') }, 10);

				// Trigger the toggle event for the details element
				this.details.dispatchEvent(new Event('toggle'));
			});
		}
	}

	handleMouseLeave() {
		this.isHovering = false;

		// Increase delay before closing to allow more time for mouse movement
		this.hoverTimer = setTimeout(() => {
			if (!this.isHovering && this.details.hasAttribute('open')) {
				this.classList.remove('animate');
				setTimeout(() => {
					this.classList.remove('on');
				}, 250);
				this.summary.setAttribute('aria-expanded', 'false');
				setTimeout(() => {
					this.details.removeAttribute('open');
				}, 260);
			}
		}, 300);
	}

	disconnectedCallback() {
		if (this.summary) {
			this.summary.removeEventListener('click', this.toggleDrawer.bind(this));
			this.summary.removeEventListener('keydown', this.handleKeyboard.bind(this));
		}

		if (this.closeBtn) {
			this.closeBtn.removeEventListener('click', this.closeDrawer.bind(this));
		}

		this.removeEventListener('click', this.clickOutsideDrawer.bind(this));
		document.removeEventListener('keydown', this.handleKeyboard.bind(this));

		if (this.isMenuDrawer) {
			this.mediaQuery.removeEventListener('change', this.updateHoverListeners.bind(this));
			this.removeEventListener('mouseenter', this.handleMouseEnter.bind(this));
			this.removeEventListener('mouseleave', this.handleMouseLeave.bind(this));
		}

		// Clear any pending timers
		if (this.hoverTimer) {
			clearTimeout(this.hoverTimer);
		}
	}

	closeOtherDrawers(event) {
		const allDrawers = document.querySelectorAll('details-drawer');
		allDrawers.forEach(drawer => {
			if (drawer !== this && drawer.details.hasAttribute('open')) {
				drawer.closeDrawer(event);
			}
		});
	}

	closeDrawer(event) {
		if (event) event.preventDefault();
		if (this.details.hasAttribute('open')) {
			this.classList.remove('animate')
			setTimeout(() => { this.classList.remove('on') }, 250)
			this.summary.setAttribute('aria-expanded', 'false');
			setTimeout(() => {
				this.details.removeAttribute('open');
				this.dealWithPageScroll();
			}, 260)
		}
	}

	toggleDrawer(event) {
		event.preventDefault();
		this.closeOtherDrawers(event);
		if (this.details.hasAttribute('open')) {
			this.classList.remove('animate')
			setTimeout(() => { this.classList.remove('on') }, 250)
			this.summary.setAttribute('aria-expanded', 'false');
			setTimeout(() => {
				this.details.removeAttribute('open');
				this.dealWithPageScroll();
			}, 260)
		} else {
			this.details.setAttribute('open', '');
			this.summary.setAttribute('aria-expanded', 'true');
			this.dealWithPageScroll();
			setTimeout(() => {
				this.classList.add('on');
				setTimeout(() => { this.classList.add('animate') }, 10)
				this.dealWithFocus();
			})
		}
	}

	dealWithPageScroll() {
		this.details.hasAttribute('open') ? document.documentElement.classList.add('overflow-hidden') : document.documentElement.classList.remove('overflow-hidden');
	}

	dealWithFocus() {
		trapFocus(this.content);
		const focusableElements = getFocusableElements(this.content);
		if (focusableElements.length > 0) {
			focusableElements[0].focus();
		}
	}

	clickOutsideDrawer(event) {
		if (event.target.tagName.toLowerCase() === 'details-drawer' && !event.target.closest('.drawer-content')) {
			this.closeDrawer(event)
		}
	}

	handleKeyboard(event) {
		if (event.key === 'Escape') {
			this.closeDrawer(event);
		}
	}

	handleMouseMove(event) {
		const hoveredElement = document.elementFromPoint(event.clientX, event.clientY);
		if (hoveredElement.tagName.toLowerCase() === 'details-drawer') {
			this.closeDrawer(event);
		}
	}
}
customElements.define('details-drawer', DetailsDrawer);


class StickyHeader extends HTMLElement {


	constructor() {
		super();
	}


	connectedCallback() {

		this.header = document.querySelector('.section-header');
		// this.announcementBar = document.querySelector('#shopify-section-announcement-bar'); announcement-bar-section
		this.announcementBar = document.querySelector('.announcement-bar-section');

		document.documentElement.style.setProperty('--announcement-height', `${this.announcementBar.offsetHeight}px`);

		this.header.classList.add('shopify-section-header-sticky');

		this.headerBounds = {};
		this.setHeaderHeight();

		this.currentScrollTop = 0;

		const scrollTop = document.documentElement.scrollTop;
		if (scrollTop > this.currentScrollTop) {
			this.header.classList.add('scrolled-past-header');
		}


		this.onScrollHandler = this.onScroll.bind(this);
		window.addEventListener('scroll', this.onScrollHandler, false);
		this.createObserver();

	}


	setHeaderHeight() {
		document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
	}


	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}


	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});
		observer.observe(this.header);
	}


	onScroll() {
		const scrollTop = document.documentElement.scrollTop;
		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.header.classList.add('scrolled-past-header');
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.header.classList.add('scrolled-past-header');
		} else if (scrollTop <= this.headerBounds.top) {
			this.header.classList.remove('scrolled-past-header');
		}
		this.currentScrollTop = scrollTop;
	}


}
customElements.define('sticky-header', StickyHeader);


class HeaderMenu extends HTMLElement {


	constructor() {
		super();
		this.opener = this.querySelector('.js-main-menu-opener');
		this.closer = this.querySelector('.js-main-menu-closer');
		this.nav = this.querySelector('nav');

		this.opener.setAttribute('aria-controls', this.nav.id ? this.nav.id : (this.nav.id = 'nav_' + Math.random().toString(36)));
		this.opener.setAttribute('aria-expanded', 'false');

		this.searchOpener = this.querySelector('#open-search-in-menu');
		this.cartOpener = this.querySelector('#open-cart-in-menu');

		this.mobBtns = this.querySelectorAll('.lvl-1-item-wrapper .mob-menu-btn');
		this.menuDrawer = this.querySelectorAll('.menu-drawer');
		//console.log(this.mobBtns)

		//this.lvl1Items = this.querySelectorAll('.lvl-1-item-wrapper');
		//console.log(this.lvl1Items)

		//this.innerListsWrapper = this.querySelector('.menu-inner-lists');
		//console.log(this.innerListsWrapper)

		this.mediaQuery = window.matchMedia('(max-width: 80em)');
		this.handleMediaQuery();
	}


	connectedCallback() {
		this.mediaQuery.addEventListener('change', this.handleMediaQuery.bind(this));
		this.addEventListener('click', this.clickOutsideMenu.bind(this));
		document.addEventListener('keydown', this.handleKeyboard.bind(this));
	}


	disconnectedCallback() {
		this.mediaQuery.removeEventListener('change', this.handleMediaQuery.bind(this));
		this.removeEventListener('click', this.clickOutsideMenu.bind(this));
		document.removeEventListener('keydown', this.handleKeyboard.bind(this));
	}


	handleMediaQuery() {
		if (this.mediaQuery.matches) {

			this.opener.addEventListener('click', () => {
				this.openMenu();
				//this.openMobSubmenus();
			})

			this.closer.addEventListener('click', this.closeMenu.bind(this));
			this.searchOpener.addEventListener('click', this.handleSearchClick.bind(this));
			this.cartOpener.addEventListener('click', this.closeMenu.bind(this));

			const detailsElements = document.querySelectorAll('.menu-drawer details');

			detailsElements.forEach(details => {
				details.addEventListener('toggle', function () {
					if (this.open) {
						// This details element was just opened
						const drawer = this.closest('.menu-drawer');
						const firstMobBtn = drawer.querySelector('.mob-menu-btn');

						if (firstMobBtn) {
							// Get the HeaderMenu instance
							const headerMenu = document.querySelector('header-menu');
							if (headerMenu) {
								// First close any open submenus
								headerMenu.closeMobSubmenus();
								// Then open the first submenu in this drawer
								headerMenu.openMobSubmenu(firstMobBtn);
								console.log("Auto-opening first submenu after details opened");
							}
						}
					}
				});
			});
			// Then modify your existing code to ensure proper event handling
			this.menuDrawer.forEach(drawer => {
				drawer.addEventListener('click', (event) => {
					// We don't need special handling here anymore
					// The toggle event listener above will handle opening the first submenu
				});
			});

			this.mobBtns.forEach(btn => {
				btn.addEventListener('click', (event) => {
					// Stop propagation to prevent conflicts
					event.stopPropagation();

					// Close all open submenus
					this.closeMobSubmenus();

					// Open the clicked submenu
					this.openMobSubmenu(btn);
					console.log("Clicked on mob-menu-btn");
				});
			});
		} else {
			this.opener.removeEventListener('click', this.openMenu);
			this.closer.removeEventListener('click', this.closeMenu);
			this.searchOpener.removeEventListener('click', this.handleSearchClick);
			this.cartOpener.removeEventListener('click', this.closeMenu);
		}
	}


	closeMobSubmenus() {
		this.mobBtns.forEach(btn => {
			btn.classList.remove('on');
			const target_ul = btn.nextElementSibling;
			const target_wrapper = btn.closest('.lvl-1-item-wrapper');
			target_ul.style.display = `none`;
			target_wrapper.style.height = `0px`;
			target_ul.style.opacity = 0;
		})
	}


	openMobSubmenu(btn) {

		const target_ul = btn.nextElementSibling;
		target_ul.style.display = `flex`;
		const target_wrapper = btn.closest('.lvl-1-item-wrapper');
		// console.log(target_ul.clientHeight)
		target_wrapper.style.height = `${target_ul.clientHeight + 85}px`;
		setTimeout(() => {
			btn.classList.add('on');
			target_ul.style.opacity = 1;
		}, 10)
	}


	handleSearchClick() {
		this.closeMenu();
		document.querySelector('.search-drawer-summary').click();
	}


	openMenu() {
		this.nav.style.display = 'flex';
		setTimeout(() => { this.classList.add('on') })
		setTimeout(() => { this.classList.add('animate') }, 10)
		this.opener.setAttribute('aria-expanded', 'true');
		this.dealWithFocus();
	}


	closeMenu() {
		// First close all details elements inside the menu
		// WHITE MENU BUG FIX
		const detailsElements = this.nav.querySelectorAll('details[open]');
		detailsElements.forEach(details => {
			details.removeAttribute('open');
			const summary = details.querySelector('summary');
			if (summary) {
				summary.setAttribute('aria-expanded', 'false');
			}
		});


		this.classList.remove('animate');
		setTimeout(() => {
			this.classList.remove('on');
			this.nav.style.display = 'none';
		}, 260)
		this.opener.setAttribute('aria-expanded', 'false');
		document.documentElement.style.overflow = 'unset';
	}


	dealWithFocus() {
		trapFocus(this.nav);
		const focusableElements = getFocusableElements(this.nav);
		if (focusableElements.length > 0) {
			focusableElements[0].focus();
		}
	}


	handleKeyboard(event) {
		if (event.key === 'Escape') {
			this.closeMenu(event);
		}
	}


	clickOutsideMenu(event) {
		if (event.target.tagName.toLowerCase() === 'header-menu' && !event.target.closest('#the-main-nav')) {
			this.closeMenu(event)
		}
	}


}
customElements.define('header-menu', HeaderMenu);


class CartCountUpdater extends HTMLElement {
	constructor() {
		super();
		this.updateCartCount = this.updateCartCount.bind(this);
		this.cartDrawerObserver = new MutationObserver(this.updateCartCount);
	}

	connectedCallback() {
		// Initialize on connection to DOM
		this.updateCartCount();

		// Listen for cart changes from add to cart events
		document.addEventListener('cart:updated', this.updateCartCount);

		// Start observing after a short delay to ensure the cart drawer is loaded
		setTimeout(() => {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) {
				this.cartDrawerObserver.observe(cartDrawer, {
					childList: true,
					subtree: true,
					attributes: true,
					attributeFilter: ['class']
				});
			}
		}, 1000);
	}

	disconnectedCallback() {
		// Clean up event listeners and observers when element is removed
		document.removeEventListener('cart:updated', this.updateCartCount);
		this.cartDrawerObserver.disconnect();
	}

	updateCartCount() {
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				// Update this element directly
				if (cart.item_count === 0) {
					this.style.display = 'none';
				} else {
					this.style.display = '';
					this.textContent = cart.item_count;
				}
			})
			.catch(error => {
				console.error('Error fetching cart:', error);
			});
	}
}

customElements.define('cart-count-updater', CartCountUpdater);


function dragScroll(scrollContainer) {

	let isDown = false;
	let startX;
	let scrollLeft;

	scrollContainer.addEventListener('mousedown', (e) => {
		isDown = true;
		scrollContainer.style.cursor = 'grabbing';
		scrollContainer.classList.add('drag-scroll-active');
		startX = e.pageX - scrollContainer.offsetLeft;
		scrollLeft = scrollContainer.scrollLeft;
	});

	scrollContainer.addEventListener('mouseleave', () => {
		isDown = false;
		scrollContainer.style.cursor = 'normal';
		scrollContainer.querySelectorAll('a').forEach((link) => { link.style.pointerEvents = "auto" });
		scrollContainer.classList.remove('drag-scroll-active');
	});

	scrollContainer.addEventListener('mouseup', () => {
		isDown = false;
		scrollContainer.style.cursor = 'grab';
		scrollContainer.querySelectorAll('a').forEach((link) => { link.style.pointerEvents = "auto" });
		scrollContainer.classList.remove('drag-scroll-active');
	});

	scrollContainer.addEventListener('mousemove', (e) => {
		if (!isDown) return;
		e.preventDefault();
		scrollContainer.querySelectorAll('a').forEach((link) => { link.style.pointerEvents = "none" });
		const x = e.pageX - scrollContainer.offsetLeft;
		const walk = (x - startX) * 3; //scroll-fast
		scrollContainer.scrollLeft = scrollLeft - walk;
	});

}


window.addEventListener('DOMContentLoaded', () => {
	const scrollContainers = document.querySelectorAll('[data-dragscroller]');
	scrollContainers.forEach((scrollContainer) => {
		dragScroll(scrollContainer);
	})
})

class ScrollAnimations {
	constructor() {
		this.options = {
			root: null,
			rootMargin: '0px',
			threshold: 0.10
		};

		// Store observer as class property
		this.observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('animated');
				}
			});
		}, this.options);

		this.init();
	}

	init() {
		this.elements = document.querySelectorAll('.animate-on-scroll:not(.observed)');
		if (!this.elements.length) return;

		this.elements.forEach(element => {
			element.classList.add('observed');
			this.observer.observe(element);
		});
	}

	// New method to handle dynamic elements
	refresh() {
		this.init();
	}
}

// Initialize animations
window.addEventListener('DOMContentLoaded', () => {
	// Don't initialize scroll animations in the customizer
	if (window.Shopify && window.Shopify.designMode) {
		const body = document.querySelector('body');
		body.classList.add('shopify-design-mode');
		return;
	}

	window.scrollAnimations = new ScrollAnimations();
});